// extracted by mini-css-extract-plugin
module.exports = {"cus-mtdicon":"hF","cusMtdicon":"hF"};